import { createFileRoute, redirect } from "@tanstack/react-router"
import { useAuthStore } from "@/store/auth.store"

export const Route = createFileRoute("/orders")({
  beforeLoad: () => {
    const { isAuthenticated, user } = useAuthStore.getState()
    if (!isAuthenticated) throw redirect({ to: "/login" })
    const role = user?.role?.toUpperCase()
    if (role === "BUYER") {
      throw redirect({ to: "/dashboard/orders" })
    }
  },
})
